(() => {
  const selector = '[data-gift-enclosure]';
  const attributeName = 'Gift enclosure cards';
  const clamp = (value) => Math.min(99, Math.max(0, Number.isFinite(value) ? Math.trunc(value) : 0));

  const updateButtons = (row, busy = false) => {
    const quantity = clamp(Number(row.querySelector('[data-gift-enclosure-input]').value));
    row.querySelectorAll('[data-gift-enclosure-step]').forEach((button) => {
      button.disabled = busy || (Number(button.dataset.giftEnclosureStep) < 0 ? quantity === 0 : quantity === 99);
    });
  };

  const save = async (row) => {
    if (row.dataset.giftEnclosureBusy === 'true') return;
    const input = row.querySelector('[data-gift-enclosure-input]');
    const error = row.querySelector('[data-gift-enclosure-error]');
    const variantId = row.dataset.variantId;
    const legacyQuantity = clamp(Number(row.dataset.legacyQuantity));
    const saved = clamp(Number(row.dataset.giftEnclosureSaved ?? input.defaultValue));
    const quantity = clamp(Number(input.value));
    input.value = String(quantity);
    error.hidden = true;
    if (quantity === saved && !(variantId && legacyQuantity)) {
      updateButtons(row);
      return;
    }

    row.dataset.giftEnclosureBusy = 'true';
    input.readOnly = true;
    updateButtons(row, true);
    let reload = false;
    try {
      const payload = variantId
        ? { updates: { [row.dataset.lineKey || variantId]: quantity }, attributes: { [attributeName]: '' } }
        : { attributes: { [attributeName]: quantity ? String(quantity) : '' } };
      const response = await fetch(row.dataset.updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      const cart = await response.json();
      if (!response.ok || cart.status) throw new Error(cart.description || cart.message || 'Gift card update failed');
      if (variantId) {
        const actualQuantity = cart.items
          .filter((item) => String(item.variant_id) === variantId)
          .reduce((total, item) => total + item.quantity, 0);
        if (actualQuantity !== quantity) throw new Error('Gift card quantity did not match the cart');
        reload = true;
      }
      row.dataset.giftEnclosureSaved = String(quantity);
      row.dataset.legacyQuantity = '0';
      input.defaultValue = String(quantity);
    } catch (exception) {
      console.error('Gift enclosure card update:', exception);
      input.value = String(saved);
      error.textContent = row.dataset.errorMessage;
      error.hidden = false;
    } finally {
      delete row.dataset.giftEnclosureBusy;
      input.readOnly = false;
      updateButtons(row);
    }
    if (reload) window.location.reload();
  };

  // Convert existing cart-attribute selections to the real free product line.
  document.querySelectorAll(selector).forEach((row) => {
    if (!row.dataset.variantId || !clamp(Number(row.dataset.legacyQuantity))) return;
    const input = row.querySelector('[data-gift-enclosure-input]');
    input.value = String(Math.max(clamp(Number(input.value)), clamp(Number(row.dataset.legacyQuantity))));
    save(row);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-gift-enclosure-step]');
    if (!button || button.disabled) return;
    const row = button.closest(selector);
    const input = row.querySelector('[data-gift-enclosure-input]');
    input.value = String(clamp(Number(input.value) + Number(button.dataset.giftEnclosureStep)));
    save(row);
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-gift-enclosure-input]')) return;
    save(event.target.closest(selector));
  });

  // Wait for the cart update before allowing checkout.
  document.addEventListener('click', (event) => {
    if (!document.querySelector(`${selector}[data-gift-enclosure-busy="true"]`)) return;
    if (event.target.closest('button[name="checkout"], input[name="checkout"], .additional-checkout-buttons')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    if (event.target.id !== 'cart') return;
    const row = event.target.querySelector(selector);
    if (!row) return;
    if (row.dataset.giftEnclosureBusy === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
    } else {
      const input = row.querySelector('[data-gift-enclosure-input]');
      if (clamp(Number(input.value)) !== clamp(Number(row.dataset.giftEnclosureSaved ?? input.defaultValue))) {
        event.preventDefault();
        save(row);
      } else if (!row.dataset.variantId && clamp(Number(input.value)) === 0) {
        input.value = '';
      }
    }
  }, true);
})();
